import React from "react";
import styles from "./Footer.module.css";
const Footer = () => {
  return (
    <div className={styles.container}>
      <p className={styles.p}>Created with 💛 by Kevin Corman Samanamud</p>
    </div>
  );
};

export default Footer;
